import { lerp } from './assets/_utils'

const recruit = document.querySelector('.footerRecruit')
const recruitBg = document.querySelectorAll('.footerRecruitBg__image')

if (recruit && recruitBg) {
  const state = {
    perCurrent: -1,
    perTarget: -1,
    power: 0.2,
    maxImgWidth: 0,
    multiplier: 0.1,
  }

  const setMaxImgWidth = () => {
    recruitBg.forEach((elm) => {
      const width = elm.clientWidth
      if (state.maxImgWidth < width) {
        state.maxImgWidth = width
      }
    })
  }
  document.addEventListener('resize', setMaxImgWidth)
  setMaxImgWidth()

  const onScroll = () => {
    const scrollCenter = document.documentElement.scrollTop + document.documentElement.clientHeight * 0.5

    const rect = recruit.getBoundingClientRect()
    const areaCenter = rect.top + rect.height * 0.5 + document.documentElement.scrollTop
    state.perTarget = ((scrollCenter - areaCenter) / rect.height).clamp(-1, 1)
  }
  document.addEventListener('scroll', onScroll)

  const update = () => {
    const { perCurrent, perTarget, power, maxImgWidth, multiplier } = state

    state.perCurrent = lerp(perCurrent, perTarget, multiplier)

    recruitBg.forEach((elm) => {
      const img = elm.querySelector('img')
      const isBack = elm.closest('.footerRecruitBg--back')

      const powerPer = Math.pow(elm.clientWidth / maxImgWidth, isBack ? 2 : 1) * power
      const pow = document.documentElement.clientHeight * powerPer * perCurrent
      img.style.transform = `translate3d(0, ${-pow}px, 0)`
    })

    requestAnimationFrame(update)
  }
  update()
}
